import React from "react";
import { Dots } from "react-activity";
import styled from "styled-components";

import { ReactComponent as LOGO_PREVIEW } from "@assets/svgs/LOGO_PREVIEW.svg";
import { Icon } from "@components/Icon";
import "react-activity/dist/library.css";
import { Text } from "@components/Text";
import { COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const LoadingSplash = ({ isLoading, hasMedias }) => {
  return (
    <Container>
      <Icon width={150} height={150}>
        <LOGO_PREVIEW />
      </Icon>
      {isLoading && <Dots size={24} color={COLOR_WHITE} />}
      {!isLoading && !hasMedias && (
        <Text color={COLOR_WHITE} fontSize="20px" fontWeight="500">
          No Media
        </Text>
      )}
    </Container>
  );
};
